class WebSocketService {
    constructor() {
        this.ws = null;
        this.connectionHandler = null;
        this.messageCallback = null;
        this.subscriptions = new Set();
    }

    connect(url) {
        try {
            this.ws = new WebSocket(url);

            this.ws.onopen = () => {
                console.log('WebSocket connected');
                if (this.connectionHandler) {
                    this.connectionHandler('connected');
                }
            };

            this.ws.onmessage = (event) => {
                if (this.messageCallback) {
                    try {
                        const data = JSON.parse(event.data);
                        this.messageCallback(data);
                    } catch (error) {
                        console.error('Failed to parse WebSocket message:', error);
                    }
                }
            };

            this.ws.onerror = (error) => {
                console.error('WebSocket error:', error);
                if (this.connectionHandler) {
                    this.connectionHandler('error');
                }
            };

            this.ws.onclose = () => {
                console.log('WebSocket closed');
                if (this.connectionHandler) {
                    this.connectionHandler('disconnected');
                }
            };

        } catch (error) {
            console.error('Failed to create WebSocket:', error);
            if (this.connectionHandler) {
                this.connectionHandler('error');
            }
        }
    }

    setConnectionHandler(handler) {
        this.connectionHandler = handler;
    }

    setMessageCallback(callback) {
        this.messageCallback = callback;
    }

    subscribeScan(scanId) {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(JSON.stringify({ type: 'subscribe_scan', scanId }));
            this.subscriptions.add(scanId);
        }
    }

    unsubscribeScan(scanId) {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(JSON.stringify({ type: 'unsubscribe_scan', scanId }));
            this.subscriptions.delete(scanId);
        }
    }

    unsubscribeAll() {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(JSON.stringify({ type: 'unsubscribe_all' }));
        }
        this.subscriptions = new Set();
    }

    isConnected() {
        return this.ws && this.ws.readyState === WebSocket.OPEN;
    }

    cleanup() {
        if (this.ws) {
            this.ws.close();
            this.ws = null;
        }
        this.subscriptions = new Set();
        this.connectionHandler = null;
        this.messageCallback = null;
    }
}

export default new WebSocketService();
